<template>
    <transition name="fade">
      <div v-if="isVisible" class="vxmodal-overlay" @click.self="closeModal2">
        <transition name="slide">
          <div class="vxmodal">
            <button class="close-button" @click="closeModal">
              <svg width="24px" height="24px" viewBox="0 0 24 24" fill="inherit">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="inherit"/>
              </svg>
            </button>
            <div style="width:100%; position: relative;">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'ModalView',
    props: {
      isVisible: {
        type: Boolean,
        required: true
      },
      fixclose:{
        type:Boolean,
        required:false,
        default:false
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      closeModal2() {
        if(!this.fixclose){
          this.$emit('close');
        }
      }
    },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  }
  }
  </script>
  
<style scoped>
  .vxmodal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000; overflow-y: auto;
  }

  .vxmodal {
    background: var(--white-color); padding: 20px; border-radius: 20px; position: relative; width: 50%;
    margin:60px auto; width: min(50%, 600px);}

  .close-button {
    position: absolute; top: -5px;
    right: -5px; background: var(--primary-color);
    cursor: pointer; border-radius: 50%; padding:4px !important;
    fill: var(--always-white); border: 0;
    height:30px; width:30px; display: flex;
    align-items: center; justify-content: center;
  }
  
  /* Fade transition */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  
  /* Slide transition */
  .slide-enter-active, .slide-leave-active {
    transition: transform 0.5s;
  }
  .slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
    transform: translateY(-10px);
  }

  @media screen and (max-width: 700px) {
    .vxmodal {width:90% !important}
  }
 
</style>
  